import React, { useEffect } from 'react';

import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import noPaymentsImage from 'common/images/noPayments.svg';
import { getWazzupIframe, getWazzupAuthorizeUrl } from '../_redux';
import { staticStyles } from './style';
import { BaseButton } from '../../_components';

const WazzupPage = ({
  iframeLink,
  iframeIsLoaded,
  needAuth,
  error,
  getWazzupIframe,
  getWazzupAuthorizeUrl,
  authUrl,
  authUrlIsLoaded,
}) => {
  useEffect(() => {
    getWazzupIframe();
  }, [getWazzupIframe]);

  useEffect(() => {
    if (authUrlIsLoaded) {
      window.location.href = authUrl;
    }
  }, [authUrl, authUrlIsLoaded]);

  const handleAuthorize = () => {
    getWazzupAuthorizeUrl();
  };

  return (
    <div className="WazzupPage">
      {!iframeIsLoaded && !needAuth && !error && (
        <div className="WazzupPage__loading">
          <FormattedMessage id="justLoading">{txt => <h3>{txt}</h3>}</FormattedMessage>
        </div>
      )}

      {needAuth && (
        <div className="WazzupPage__auth">
          <img src={noPaymentsImage} alt="" />
          <div className="WazzupPage__authText">
            <FormattedMessage id="wazzupIsNotConnected">{txt => <h3>{txt}</h3>}</FormattedMessage>
          </div>

          <BaseButton
            type="button"
            className="WazzupPage__authButton"
            textId="connectWazzup"
            onClick={handleAuthorize}
          />
        </div>
      )}

      {iframeIsLoaded && iframeLink && (
        <iframe
          src={iframeLink}
          title="Wazzup"
          width="100%"
          height="100%"
          className="WazzupPage__iframe"
          allow="clipboard-read; clipboard-write"
        />
      )}

      <style jsx>{staticStyles}</style>
    </div>
  );
};

WazzupPage.propTypes = {
  iframeLink: PropTypes.string,
  iframeIsLoaded: PropTypes.bool.isRequired,
  needAuth: PropTypes.bool.isRequired,
  getWazzupIframe: PropTypes.func.isRequired,
  error: PropTypes.string,
  getWazzupAuthorizeUrl: PropTypes.func.isRequired,
  authUrl: PropTypes.string.isRequired,
  authUrlIsLoaded: PropTypes.bool.isRequired,
};

WazzupPage.defaultProps = {
  iframeLink: '',
  error: '',
};

export default connect(
  state => ({
    iframeLink: state.crm.wazzup.iframeLink,
    iframeIsLoaded: state.crm.wazzup.iframeIsLoaded,
    needAuth: state.crm.wazzup.needAuth,
    error: state.crm.wazzup.error,
    authUrl: state.crm.wazzup.authUrl,
    authUrlIsLoaded: state.crm.wazzup.authUrlIsLoaded,
  }),
  { getWazzupIframe: () => getWazzupIframe.request(), getWazzupAuthorizeUrl: () => getWazzupAuthorizeUrl.request() }
)(WazzupPage);
